import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { generateOtp, generateMobOtp, verifyOtp, verifymobOtp } from "../configs/WebService";
import { type } from "@testing-library/user-event/dist/cjs/utility/type.js";
import { setAppdAiGuest } from "../utils/appdAiHelpers";
import { handleUserData, setAuthData } from "../auth/authSlice";
import userStore from "../zustand/userStore";
import { useDispatch } from "react-redux";
// Replace this with your actual API endpoint
const WSVerifyOTP = "https://your-domain.com/api/verify-otp";

const OtpVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasInitialized = useRef(false);

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [step, setStep] = useState("email"); // "email" or "mobile"
  const [userPayload, setUserPayload] = useState(null); // Full payload from signup
  const payload = location.state?.formData;
  const source = location.state?.source;
  const phone = payload?.contactNumber || payload?.contact_number;
  const setUser = userStore.getState().setUser;

  useEffect(() => {
    setAppdAiGuest("registration");
  }, []);

  useEffect(() => {
    // 2. Only run the logic if it hasn't run before and state exists
    if (hasInitialized.current || !location.state) return;
    if (source === "login") {
      if (payload?.email && !phone) {
        setEmail(payload.email);
        setMobile("");
        setUserPayload(payload);
        sendOtpToEmail(payload.email);
        hasInitialized.current = true; // Mark as done
      } else if (phone && !payload?.email) {
        setStep("mobile");
        setMobile(phone);
        setUserPayload(payload);
        sendOtpToMobile(phone);
        hasInitialized.current = true; // Mark as done
      } else if (payload?.email && phone) {
        setEmail(payload.email);
        setMobile(phone);
        setUserPayload(payload);
        sendOtpToEmail(payload.email);
        hasInitialized.current = true; // Mark as done
      }
    } else {
      // Signup Logic
      if (payload?.email && phone) {
        setEmail(payload.email);
        setMobile(phone);
        setUserPayload(payload);
        sendOtpToEmail(payload.email);
        hasInitialized.current = true; // Mark as done
      } else {
        alert("No user data found. Redirecting...");
        navigate("/signup");
      }
    }
  }, [location, navigate]);

  const sendOtpToMobile = async (mobileNumber) => {
    try {
      const response = await fetch(generateMobOtp, { // Using your mobile config
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ otpType: "mobile", otpSentTo: mobileNumber }), // Ensure your backend expects 'to'
      });

      if (response.ok) {
        console.log("OTP sent successfully to mobile:", mobileNumber);
        document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'sent' } }));
        alert("Now, an OTP has been sent to your mobile.");
      } else {
        alert("Email verified, but failed to send Mobile OTP. Please use Resend.");
      }
    } catch (error) {
      console.error("Mobile OTP error:", error);
    }
  };

  const sendOtpToEmail = async (email) => {
    try {
      const response = await fetch(generateOtp, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ to: email, otpType: "email_verify" }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("OTP sent successfully to:", email);
        document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'sent' } }));
      } else {
        console.error("OTP send error:", data?.error || "Unknown error");
        alert("Failed to send OTP: " + (data?.error || "Please try again."));
      }
    } catch (error) {
      console.error("Network error while sending OTP:", error);
      alert("Network error. Please try again later.");
    }
  };


  // const handleVerifyOtp = async (e) => {
  //   e.preventDefault();

  //   if (!otp) {
  //     alert("Please enter the OTP.");
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const response = await fetch(verifyOtp, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         to: step==="email" ? email:mobile,
  //         otp:otp,
  //       }),
  //     });

  //     const data = await response.json();

  //     if (response.ok) {
  //       alert(`✅ ${step === "email" ? "Email" : "Mobile"} OTP Verified Successfully!`);
  //       setOtp(""); // clear input

  //       if (step === "email") {
  //         //navigate("/login");
  //         setStep("mobile"); //uncomment for mobile otp
  //         sendOtpToMobile(mobile);
  //       }else{
  //         navigate("/login");
  //       }

  //     } else {
  //       alert("❌ Invalid OTP: " + (data?.error || "Please try again."));
  //     }
  //   } catch (error) {
  //     console.error("OTP verification error:", error);
  //     alert("Network error during OTP verification.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!otp) {
      alert("Please enter the OTP.");
      return;
    }

    setLoading(true);

    // 1. Determine which API and Payload to use based on the current step
    const apiUrl = step === "email" ? verifyOtp : verifymobOtp; // Update with your actual full mobile verify URL

    const payload = step === "email"
      ? { to: email, otp: otp, otpType: "email_verify" }
      : { to: mobile, otp: otp }; // Mobile usually expects 'otpSentTo' based on your previous thunk

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("data_182", data)

      if (response.ok) {
        if (step === "email") {
          // --- EMAIL SUCCESS ---
          document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'verified' } }));
          alert("✅ Email Verified!");
          setOtp("");
          if (phone) {
            setStep("mobile"); // This updates your UI text automatically               
            await sendOtpToMobile(mobile);
          } else {
            navigate("/login");
          }
        } else {
          // --- MOBILE SUCCESS ---
          document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'verified' } }));
          alert("✅ Mobile Verified Successfully!");
          dispatch(setAuthData(data));
          setUser(data.user);
          // navigate("/login");
          navigate("/paywall");
        }
      } else {
        alert("❌ Verification Failed: " + (data?.message || data?.error || "Invalid OTP"));
      }
    } catch (error) {
      console.error("Verification Error:", error);
      alert("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleResendOtp = async () => {
    setLoading(true);

    try {
      // 1. Determine which URL to hit
      const targetApi = step === "email" ? generateOtp : generateMobOtp;

      // 2. Prepare the correct payload for each step
      const payload = step === "email"
        ? { to: email, otpType: "email_verify" }
        : { otpType: "mobile", otpSentTo: mobile };

      const response = await fetch(targetApi, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        document.dispatchEvent(new CustomEvent('mdm:otp', { detail: { status: 'sent' } }));
        alert(`OTP resent successfully to your ${step === "email" ? "Email" : "Mobile"}.`);
      } else {
        alert("Failed to resend OTP: " + (data.error || "Please try again later."));
      }
    } catch (error) {
      console.error("Resend OTP error:", error);
      alert("Network error during OTP resend.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelVerification = () => {
    const confirmCancel = window.confirm("Are you sure you want to quit verification?");
    if (confirmCancel) {
      navigate("/signup"); // 🔁 or any route where you want to send the user
    }
  };

  return (
    <div
      style={{
        maxWidth: "400px",
        margin: "2rem auto",
        padding: "2rem",
        border: "1px solid #ccc",
        borderRadius: "8px",
      }}
    >
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={handleCancelVerification}
          style={{ fontSize: "0.5rem" }}
        ></button>
      </div>

      <p className="mb-4 text-center">Verify {step === "email" ? "Email" : "Mobile"}</p>
      <p className="text-center">
        Enter the OTP sent to <strong>{step === "email" ? email : mobile}</strong>
      </p>

      <form onSubmit={handleVerifyOtp}>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Enter  OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            maxLength={10}
          />
        </div>

        <button type="submit" className="btn btn-success w-100" disabled={loading}>
          {loading ? "Verifying..." : "Verify OTP"}
        </button>
      </form>

      <div className="text-center mt-3">
        <button className="btn btn-link" onClick={handleResendOtp} disabled={loading}>
          Resend OTP
        </button>
      </div>
    </div>
  );
};

export default OtpVerification;
